import {DishModel} from './dish.model';

export class CategoriesModel {
  category: string;
  menu?: DishModel[];
}
